export default __webpack_public_path__ + "static/media/Entertainment.422f36e7.svg";